<script setup lang="ts">import { createPropsRestProxy } from '/vue-macros/reactivity-transform/helper';
const content = createPropsRestProxy(__props, ["item","root"]);

import Tooltip from "@/components/Tooltip/Tooltip.vue";

import type { Metadata } from "@/models/Metadata";
import type { TooltipContentProps, TooltipRootProps } from "reka-ui";

withDefaults(defineProps<{ item: Metadata; root?: TooltipRootProps } & TooltipContentProps>(), {  })
</script>
<template>
  <Tooltip :content-props="content" :root-props="root">
    <template #trigger>
      <slot :disabled="root?.disabled" />
    </template>
    <template #content>
      <dl>
        <dt class="tw-mb-1">Pre-convert details</dt>
        <dd>
          Status: <strong>{{ item.edxPreConvertStatus }}</strong>
        </dd>
      </dl>
    </template>
  </Tooltip>
</template>
